import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { customStyles2 } from "../../../../util/TableStyles"
import { noDataComponent } from "../../../../util/DataObject"
import { Box } from '@mui/material';
import moment from 'moment';
moment.locale('es');

const useExpandableHistory = (row) => {
    const [data, setData] = useState([]);
    
    useEffect(() => {
        setData(row.data.history)
    }, [row])

    const columns = [
        { selector: (row) => moment(row.cdate).format('L'), name: "Fecha", wrap: true, width: "16%" },
        { selector: (row) => row.code_reason, name: "Código", wrap: true, width: "16%" },
        { selector: (row) => row.description_reason ? row.description_reason : 'N/A', name: "Descripción", wrap: true, width: "40%" },
    ]

    return (
        <Box p={2} pl={6}>
            <DataTable
                columns={columns}
                data={data}
                customStyles={customStyles2}
                noDataComponent={noDataComponent}
                highlightOnHover
                dense
            />
        </Box>
    )
}

export default useExpandableHistory;